<template>
  <message-display v-bind="{ text, backUrl, errorCode, languageCode, ...messageState }" />
</template>

<script>
import MessageDisplay from './MessageDisplay';

export default {
  name: 'MessageView',
  components: { MessageDisplay },
  status: {
    errorStateHR: {
      description: `Ne brinite, radimo na otklanjanju problema.
      U međuvremenu okušajte sreću ponovno ili u drugim igrama.
      Za povratak, kliknite dugme 'Povratak'.`,
      title: 'Neki problem je iskrsnuo...',
      errorText: 'Error kod:',
      backText: 'Povratak',
      icon: 'ic-error.png'
    },
    infoStateHR: {
      description: '',
      title: 'Moramo vam nešto poručiti...',
      backText: 'Povratak',
      icon: 'ic-info.png'
    },
    errorStateEN: {
      description: `Don't worry it's not you, it's us.
        We are working tirelessly to resolve this issue.
        In the meantime click back.`,
      title: 'Ups... Something went wrong',
      errorText: 'Error code:',
      backText: 'Go back',
      icon: 'ic-error.png'
    },
    infoStateEN: {
      description: '',
      title: 'We have something to tell you...',
      backText: 'Go back',
      icon: 'ic-info.png'
    },
    errorStateRO: {
      description: `Nu-ți face griji, nu ești tu, ci noi.
        Lucrăm neobosit pentru a rezolva această problemă.
        Între timp dați clic înapoi.`,
      title: 'Ups... Ceva a mers prost',
      errorText: 'Cod de eroare:',
      backText: 'Întoarce-te',
      icon: 'ic-error.png'
    },
    infoStateRO: {
      description: '',
      title: 'Avem ceva să vă spunem...',
      backText: 'Întoarce-te',
      icon: 'ic-info.png'
    },
    errorStateCS: {
      description: `Nebojte se, nejste to vy, ale my.
        Na vyřešení tohoto problému neúnavně pracujeme.
        Mezitím klikněte "Vrátit se".`,
      title: 'Ups... Něco se pokazilo',
      errorText: 'Chybový kód:',
      backText: 'Vrátit se',
      icon: 'ic-error.png'
    },
    infoStateCS: {
      description: '',
      title: 'Máme vám co říct...',
      backText: 'Vrátit se',
      icon: 'ic-info.png'
    }
  },
  data() {
    return {
      text: '',
      type: '',
      backUrl: '',
      languageCode: 'EN',
      errorCode: '',
      messageState: {},
      activeLanguageCodes: ['EN', 'RO', 'HR', 'CS']
    }
  },
  created() {
    const { text, type, closeurl, exitUrl, errorCode, languageCode } = this.$route.query;
    const status = this.$options.status;
    this.text = decodeURI(text);
    this.type = type;
    this.backUrl = closeurl ? closeurl : exitUrl;

    if(languageCode && this.activeLanguageCodes.includes(languageCode.toUpperCase())) this.languageCode = languageCode.toUpperCase();

    if(this.type === 'error') {
      this.errorCode = errorCode;
      this.messageState = status[`errorState${this.languageCode}`];
    } else {
      this.messageState = status[`infoState${this.languageCode}`];
    }
  }
}
</script>
